export const SOURCE = {
	ISSUE_VIEW: 'issue-view',
	CREATE_ISSUE: 'create-issue',
	CREATE_LINK: 'create-link',
} as const;

export type Source = (typeof SOURCE)[keyof typeof SOURCE];
